import axios from "axios";

console.log("API baseURL:", process.env.REACT_APP_API_BASE_URL);

const api = axios.create({
	baseURL: process.env.REACT_APP_API_BASE_URL
});

// Log all requests for debugging
api.interceptors.request.use(request => {
	console.log('Starting Request:', request.method?.toUpperCase(), request.url, 'baseURL:', request.baseURL);
	return request;
});

export default api;
